import * as angular from 'angular';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface BatchFormulasService {
  get(plantId: string): angular.IPromise<apsViewModels.BatchFormulaItem[]>;
  getDetail(plantId: string, id: string): angular.IPromise<apsViewModels.BatchFormulaDetail>;
  add(command: apsCommands.AddBatchFormula): angular.IPromise<any>;
  update(command: apsCommands.UpdateBatchFormula): angular.IPromise<any>;
  remove(command: apsCommands.RemoveBatchFormula): angular.IPromise<any>;
  getUsages(plantId: string, tankId: string, limit?: number): angular.IPromise<apsViewModels.BatchFormulaUsageItem[]>;
  addUsage(command: apsCommands.AddBatchFormulaUsage): angular.IPromise<any>;
  updateUsage(command: apsCommands.UpdateBatchFormulaUsage): angular.IPromise<any>;
  removeUsage(command: apsCommands.RemoveBatchFormulaUsage): angular.IPromise<any>;
  getUsageReport(plantId: string, tankId: string, startTime: Date, endTime?: Date): angular.IPromise<apsViewModels.BatchFormulaUsageDetail[]>;
}

class BatchFormulasSvc implements BatchFormulasService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  get(plantId: string): angular.IPromise<apsViewModels.BatchFormulaItem[]> {
    return this.httpService.get<apsViewModels.BatchFormulaItem[]>(Endpoints.BATCH_FORMULAS, { plantId: plantId });
  }

  getDetail(plantId: string, id: string): angular.IPromise<apsViewModels.BatchFormulaDetail> {
    let uri = `${Endpoints.BATCH_FORMULAS}/${id}`;
    return this.httpService.get<apsViewModels.BatchFormulaDetail>(uri, { plantId: plantId });
  }

  add(command: apsCommands.AddBatchFormula): angular.IPromise<any> {
    return this.httpService.post(Endpoints.BATCH_FORMULAS, command);
  }

  update(command: apsCommands.UpdateBatchFormula): angular.IPromise<any> {
    return this.httpService.put(Endpoints.BATCH_FORMULAS, command);
  }

  remove(command: apsCommands.RemoveBatchFormula): angular.IPromise<any> {
    return this.httpService.delete(Endpoints.BATCH_FORMULAS + '/' + command.id,
      { plantId: command.plantId });
  }

  getUsages(plantId: string, tankId: string, limit?: number): angular.IPromise<apsViewModels.BatchFormulaUsageItem[]> {
    return this.httpService.get<apsViewModels.BatchFormulaUsageItem[]>(
      Endpoints.BATCH_FORMULA_USAGES, { plantId: plantId, tankId: tankId, limit: limit });
  }

  addUsage(command: apsCommands.AddBatchFormulaUsage): angular.IPromise<any> {
    return this.httpService.post(Endpoints.BATCH_FORMULA_USAGES, command);
  }

  updateUsage(command: apsCommands.UpdateBatchFormulaUsage): angular.IPromise<any> {
    return this.httpService.put(Endpoints.BATCH_FORMULA_USAGES, command);
  }

  removeUsage(command: apsCommands.RemoveBatchFormulaUsage): angular.IPromise<any> {
    return this.httpService.delete(Endpoints.BATCH_FORMULA_USAGES + '/' + command.id);
  }

  getUsageReport(plantId: string, tankId: string, startTime: Date, endTime?: Date): angular.IPromise<apsViewModels.BatchFormulaUsageDetail[]> {
    return this.httpService.get<apsViewModels.BatchFormulaUsageDetail[]>(
      Endpoints.BATCH_FORMULA_USAGE_REPORT, { plantId: plantId, tankId: tankId, startTime: startTime, endTime: endTime });
  }
}

export default angular
  .module('aps.services.batchFormulas', [HttpServiceName])
  .service('batchFormulasService', BatchFormulasSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/batches/batchFormulas.service.ts